import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import ModalComponent from "../ModalComponent";
import GlobalStyles from "../../globalStyles/globalStyles";
import { Colors } from "../../globalStyles/ColorConfig";
import CustomComponent from "../../components/CustomComponent";

interface DifferentMethodProps {
  isDialog?: boolean;
  isVisible: boolean;
  toggleModal: () => void;
  method1: any;
  method2: any;
}

export default function DifferentMethod({
  isDialog = false,
  isVisible,
  toggleModal,
  method1,
  method2,
}: DifferentMethodProps) {
  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View style={styles.ErrorContainer}>
        <CustomComponent.TextView
          title={"Something went wrong with Google id"}
          textStyle={GlobalStyles.heading3}
          boxStyle={{
            paddingVertical: 30,
            right: 10,
          }}
        />
        <CustomComponent.SolidDivider
          width={328}
          height={0.5}
          backgroundColor={Colors.black90}
        />
        <View style={{ width: 328, flexDirection: "row" }}>
          <TouchableOpacity onPress={method1}>
            <CustomComponent.TextView
              title={"Retry"}
              textStyle={GlobalStyles.bodyText}
              boxStyle={styles.method1View}
            />
          </TouchableOpacity>
          <TouchableOpacity onPress={method2}>
            <CustomComponent.TextView
              title={"Try different method"}
              textStyle={[GlobalStyles.bodyTextBold, { color: Colors.white10 }]}
              boxStyle={styles.method2View}
            />
          </TouchableOpacity>
        </View>
      </View>
    </ModalComponent>
  );
}
const styles = StyleSheet.create({
  ErrorContainer: {
    backgroundColor: "white",
    width: 328,
    borderRadius: 8,
    paddingHorizontal: 16,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  method1View: {
    width: 136,
    height: 50,
    alignItems: "center",
    justifyContent: "center",
  },
  method2View: {
    width: 192,
    height: 50,
    backgroundColor: "#1F3930",
    alignItems: "center",
    justifyContent: "center",
  },
});
